import {
  AbsoluteCenter,
  Badge,
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Container,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  Icon,
  IconButton,
  Input,
  Select,
  SimpleGrid,
  Spacer,
  Stack,
  StackDivider,
  Tag,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import { FaCircleChevronRight } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import { SubTarget } from "types/SubTarget";
import { Target } from "types/Target";

type TargetListCardProps = {
  is_active: boolean;
  target: Target;
  index: number;
};

export default function TargetListCard({ is_active, target, index }: TargetListCardProps) {

  const colors = ["red", "orange", "yellow", "green", "teal", "blue", "pink"];

  return (
    <Card shadow={"md"} mb={10} size={"sm"} variant={"outline"} 
    style={{
      borderLeft: `5px solid var(--chakra-colors-${colors[index % colors.length]}-300`,
    }}>
      <CardBody>

        <Flex 
        >
          <Heading as="h2" fontSize={"2xl"} >
            Obiettivo {target?.index} - {target?.title}
          </Heading>
          <Spacer />
          <NavLink
            to={`/targets/${target.index}`}
          >
            <IconButton variant="outline" className="targetCardListIcon" icon={<FaCircleChevronRight />} aria-label={""}
            backgroundColor={
              `${colors[index]}.200`
            }
            _hover={
              {
                backgroundColor: `${colors[index]}.300`
              }
            }
            />
          </NavLink>
        </Flex>
        <Divider my={1}/>
        <Text align={"left"}>
          {target?.description}.
        </Text>
      </CardBody>
    </Card>
  );
}
